import * as types from '../actions/actiontypes'; //just externalizes action name constants
import initialState from './initialstate';

export default function CountriesDetailsReducer(state = {}, action) {
	switch (action.type) {
		case types.GET_COUNTRIES_DATA:
			return action.response;
		default:
			return state;
	}
}
